// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["collapsed", "expanded", "label", "cancel"];

  #primary = false;
  #open = false;
  #originalLabel = "";
  #label = "";
  #wizardButtons;

  connect() {
    this.#wizardButtons = document.querySelectorAll("#wizardSteps");
    this.#primary = this.element.classList.contains("primary");
    this.#originalLabel = this.labelTarget.innerText.replace(/[\n\r]+|[\s]{2,}/g, " ");
    this.expandedTarget.addEventListener("submitted", () => this.onSubmit());
  }

  toggle() {
    this.#open = !this.#open;
    this.collapsedTarget.hidden = this.#open;
    this.expandedTarget.hidden = !this.#open;

    if (!this.#open) {
      this.fireCloseNewFormEvent();
    }
  }

  fireCloseNewFormEvent() {
    const event = new CustomEvent("close-new-form", { bubbles: true });
    this.element.dispatchEvent(event);
  }

}
